import ReplaceAllUtil from './ReplaceAll';

export const ReplaceAll = ReplaceAllUtil;



// WEBPACK FOOTER //
// ./src/components/Util/index.js